function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#38F997;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69,98.3l-13.4,0l-13.4,0l-19-19l0-13.4l0-13.4l19-19l13.4,0l13.4,0l19,19l0,13.4l0,13.4L69,98.3z M55.5,90.3l10.1,0 L80,76l0-10.1l0-10.1L65.7,41.4l-10.1,0l-10.1,0L31.1,55.8l0,10.1l0,10.1l14.3,14.3L55.5,90.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M88.1,79.1l-13.4,0l-13.4,0l-19-19l0-13.4l0-13.4l19-19l13.4,0l13.4,0l19,19l0,13.4l0,13.4L88.1,79.1z  M74.7,71.1l10.1,0l14.3-14.3l0-10.1l0-10.1L84.8,22.2l-10.1,0l-10.1,0L50.2,36.5l0,10.1l0,10.1l14.3,14.3L74.7,71.1z"
}));

function SvgUnifiNotext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, _ref3), _ref4));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiNotext);
export default __webpack_public_path__ + "static/media/Unifi-notext.6054a41e.svg";
export { ForwardRef as ReactComponent };